/* eslint-disable */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getMostActiveUsersList, getStatisticsSuccess } from "../../../actions";
import { history } from "../../../config/stores";
import Popup from "reactjs-popup";
import moment from "moment";
import Inputs from "../../Inputs";
import PeriodSelector from "../../PeriodSelector";
import "./styles.scss";
import searchIcon from '../../../assets/icons/searchIcon.png';
import infoIcon from '../../../assets/icons/info-icon-black.svg'

const MostActiveUsers = ({ getMostActiveUsersList, mostActiveUsersList, totalPagesMostActiveUsers }) => {
  const [selPeriod, setSelPeriod] = useState({
    startDate: null,
    endDate: null,
  });
  const [selectedPeriodLabel, setSelectedPeriodLabel] = useState("All time");
  const [selectedPeriodType, setSelectedPeriodType] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showUserModal, setShowUserModal] = useState(false);

  useEffect(() => {
    // Initial load
    handleLoadData();
  }, []);

  useEffect(() => {
    // Load data when period changes
    if (selPeriod.startDate !== null && selPeriod.startDate !== "") {
      handleLoadData();
    }
  }, [selPeriod.startDate]);

  const handleLoadData = (page = 1) => {
    setIsLoading(true);
    const payload = {
      page,
      limit: 20,
      startDate: selPeriod.startDate,
      endDate: selPeriod.endDate,
      search: "", // Remove search from API call
      onSuccess: (data) => {
        setIsLoading(false);
        // Store all users and apply current search filter
        const newData = Array.isArray(data) ? data : (mostActiveUsersList || []);
        if (page === 1) {
          setAllUsers(newData);
          applySearchFilter(searchTerm, newData);
        } else {
          // For pagination, append new users
          const newAllUsers = [...allUsers, ...newData];
          setAllUsers(newAllUsers);
          applySearchFilter(searchTerm, newAllUsers);
        }
      },
      onError: () => setIsLoading(false)
    };

    getMostActiveUsersList(payload);
  };

  const applySearchFilter = (term, usersList = allUsers) => {
    // Ensure usersList is always an array
    const safeUsersList = Array.isArray(usersList) ? usersList : [];
    
    if (!term || term.trim() === "") {
      setFilteredUsers(safeUsersList);
      return;
    }

    const filtered = safeUsersList.filter(user => {
      const fullName = user.user?.fullName || "";
      const searchLower = term.toLowerCase();
      return fullName.toLowerCase().includes(searchLower);
    });

    setFilteredUsers(filtered);
  };

  const handleAllSelection = () => {
    setIsLoading(true);
    getMostActiveUsersList({
      page: 1,
      limit: 20,
      startDate: null,
      endDate: null,
      search: "", // Remove search from API call
      onSuccess: (data) => {
        setIsLoading(false);
        const newData = Array.isArray(data) ? data : (mostActiveUsersList || []);
        setAllUsers(newData);
        applySearchFilter(searchTerm, newData);
      },
      onError: () => setIsLoading(false)
    });
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    setCurrentPage(1);
    // Apply filter to existing data instead of API call
    // Use mostActiveUsersList if allUsers is not populated yet
    const currentUsers = allUsers.length > 0 ? allUsers : (mostActiveUsersList || []);
    applySearchFilter(value, currentUsers);
  };

  const toggleSearchInput = () => {
    // Navigate to the user search page
    history.push("/user-search");
  };

  const handleLoadMore = () => {
    // Only load more if we're not currently searching (showing all users)
    if (currentPage < totalPagesMostActiveUsers && !isLoading && !searchTerm) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      handleLoadData(nextPage);
    }
  };

  const handlePeriodApply = (periodData) => {
    setSelPeriod({
      startDate: periodData.startDate,
      endDate: periodData.endDate,
    });
    setSelectedPeriodLabel(periodData.label);
    setSelectedPeriodType(periodData.type);
    setCurrentPage(1); // Reset to first page
    
    // Handle API call logic
    if (periodData.type === "all") {
      handleAllSelection();
    } else if (periodData.startDate) {
      setIsLoading(true);
      const payload = {
        page: 1,
        limit: 20,
        startDate: periodData.startDate,
        endDate: periodData.endDate,
        search: "",
        onSuccess: (data) => {
          setIsLoading(false);
          const newData = Array.isArray(data) ? data : (mostActiveUsersList || []);
          setAllUsers(newData);
          applySearchFilter(searchTerm, newData);
        },
        onError: () => setIsLoading(false)
      };
      getMostActiveUsersList(payload);
    }
  };

  const handleUserInfoClick = (user) => {
    setSelectedUser(user);
    setShowUserModal(true);
  };

  const closeUserModal = () => {
    setShowUserModal(false);
    setSelectedUser(null);
  };

  // Get the users to display (filtered or all)
  const usersToDisplay = searchTerm ? filteredUsers : (mostActiveUsersList || []);

  return (
    <div className="statistics-sessions-container col most-active-users-container">
      <div className="statistics-sessions-header row">
        <div className="search-icon-wrapper" onClick={toggleSearchInput}>
            <img src={searchIcon} alt="Search" className="search-icon-img" />
        </div>
        <h2>
          <span>
            <b>MOST ACTIVE USERS</b>
          </span>
          <div className="header-controls">
            <p className="period-label">
              {selectedPeriodLabel}
            </p>
            <Popup
              className="popup-header-options-container"
              trigger={<div className="settings-icon" />}
              position="bottom right"
              closeOnDocumentClick
            >
              {(close) => (
                <PeriodSelector
                  selectedPeriod={selectedPeriodType}
                  onApply={(periodData) => {
                    handlePeriodApply(periodData);
                    close();
                  }}
                />
              )}
            </Popup>
          </div>
        </h2>
      </div>

      {/* Users List */}
      <div className="most-active-users-content">
        {isLoading && currentPage === 1 ? (
          <div className="loading-container">
            <div>Loading...</div>
          </div>
        ) : usersToDisplay && usersToDisplay.length > 0 ? (
          <div className="users-list">
            {usersToDisplay.map((user, index) => (
              <div key={index} className="user-row">
                <div className="user-info">
                  <div className="user-name">{user.user?.fullName || "Unknown User"}</div>
                  <div className="user-role-container">
                    <div className="user-role">{user.user?.roles?.[0] || "USER"}</div>
                    {(user.user?.roles?.[0] === "MULTIPLE ROLES") && (
                      <img src={infoIcon} alt="Multiple Roles Info" className="role-info-icon" />
                    )}
                  </div>
                </div>
                <div className="user-sessions">
                  <div className="sessions-count">{user.sessionsCount || 0}</div>
                  <div className="sessions-label">SESSIONS</div>
                </div>
                <div className="info-icon-container">
                  <img 
                    src={infoIcon} 
                    alt="Info" 
                    className="info-icon" 
                    onClick={() => handleUserInfoClick(user)}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            ))}
            
            {/* Load More Button - Only show when not searching and more pages available */}
            {currentPage < totalPagesMostActiveUsers && !searchTerm && (
              <div className="load-more-container">
                <button
                  onClick={handleLoadMore}
                  disabled={isLoading}
                  className="load-more-button"
                >
                  {isLoading ? "Loading..." : "Load More"}
                </button>
              </div>
            )}
          </div>
        ) : (
          <div className="empty-state">
            <p>{searchTerm ? `No users found matching "${searchTerm}"` : "No active users found"}</p>
          </div>
        )}
      </div>

      {/* User Activity Modal */}
      {showUserModal && selectedUser && (
        <div className="modal-overlay">
          <div className="user-activity-modal">
            <div className="modal-header">
              <h3>USER ACTIVITY STATUS</h3>
              <span className="close-icon-styles" onClick={closeUserModal}>×</span>
            </div>
            <div className="modal-content">
              <div className="user-info-container">
                <div className="user-profile-section">
                  <div className="profile-avatar">
                    {selectedUser.user?.avatar ? (
                      <img src={selectedUser.user.avatar} alt="User Avatar" />
                    ) : (
                      <div className="avatar-placeholder">
                        {selectedUser.user?.fullName?.charAt(0) || "U"}
                      </div>
                    )}
                  </div>
                  <div className="profile-info">
                    <div className="profile-name">{selectedUser.user?.fullName || "Unknown User"}</div>
                    <div className="profile-role">{selectedUser.user?.roles?.[0] || "USER"}</div>
                  </div>
                </div>
                <div className="activity-info-section">
                  <span className="activity-item">
                    Last activity: <strong>12.05.2024 | 14:40</strong> | Last received notification: <strong>10.05.2024 | 18:20</strong> | App active on device: <strong style={{ color: '#28a745' }}>
                      {selectedUser.user?.pushToken ? 'Yes' : 'No'}
                    </strong>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  mostActiveUsersList: state.dashboard.mostActiveUsersList,
  totalPagesMostActiveUsers: state.dashboard.totalPagesMostActiveUsers,
});

const mapDispatchToProps = (dispatch) => ({
  getMostActiveUsersList: (payload) => dispatch(getMostActiveUsersList(payload)),
  getStatisticsSuccess: (payload) => dispatch(getStatisticsSuccess(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MostActiveUsers);
